import { render, staticRenderFns } from "./tnc-vn.vue?vue&type=template&id=d309dde6&scoped=true"
import script from "./tnc-vn.vue?vue&type=script&lang=js"
export * from "./tnc-vn.vue?vue&type=script&lang=js"
import style0 from "./tnc-vn.vue?vue&type=style&index=0&id=d309dde6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d309dde6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d309dde6')) {
      api.createRecord('d309dde6', component.options)
    } else {
      api.reload('d309dde6', component.options)
    }
    module.hot.accept("./tnc-vn.vue?vue&type=template&id=d309dde6&scoped=true", function () {
      api.rerender('d309dde6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-vn.vue"
export default component.exports